// Global timezone configuration for the application
// This ensures all components use Indian Standard Time consistently

import { getCurrentISTDate, formatDateWithWeekdayIST } from '../utils/timezone';

// Set default timezone for the application
export const APP_TIMEZONE = 'Asia/Kolkata';
export const TIMEZONE_NAME = 'Indian Standard Time (IST)';

// Initialize timezone on app load
export const initializeTimezone = () => {
  // Log timezone initialization
  console.log(`🕐 Application timezone initialized: ${TIMEZONE_NAME}`);
  console.log(`📅 Current IST time: ${formatDateWithWeekdayIST()}`);
  
  // Set a global flag to indicate timezone is configured
  window.APP_TIMEZONE_CONFIGURED = true;
  window.APP_CURRENT_TIMEZONE = APP_TIMEZONE;
};

// Utility to check if timezone is properly configured
export const isTimezoneConfigured = () => {
  return window.APP_TIMEZONE_CONFIGURED === true;
};

export default {
  APP_TIMEZONE,
  TIMEZONE_NAME,
  initializeTimezone,
  isTimezoneConfigured
};